<app-books-list [books]="books$ | async" (edit)="editBook($event)"></app-books-list>
